<template>
  <div v-if="user" style="position:relative">
    <Note collection="users" :objectId="$route.params.id" :pinnable="false" />
    <h1 style="margin: 20px" v-if="user.deleted">DELETED</h1>
    <h1 style="margin: 20px">User {{user.firstName}} {{user.lastName}}</h1>
    <h1 v-if="user.debt" style="color:black"> DEBT {{user.debt / 100}}</h1>
    <h1 style="margin: 20px">
      <span v-if="user.awaitingVerification" style="color:#AF23A2">WAITING VERIFICATION</span>
      <span v-if="user.verified" style="color:green">VERIFIED</span>
      <span v-if="user.verified && user.proType === 'business'" style="color:orange"> BUSINESS</span>
      <span v-if="user.proType === 'saas'" style="color:orange"> SAAS PRO</span>
      <span v-if="user.proType === 'saasCandidate'" style="color:gray"> SAAS CANDIDATE</span>
      <span v-if="user.verified && user.availabilityConfig" style="color:blue"> CALENDAR</span>
      <span v-if="user.ordersDisabled" style="color:gray"> DISABLED</span>
      <span v-if="user.legalStatus" style="color:black"> OFFENDER</span>
    </h1>
    <div style="display:flex;justify-content: center">
      <router-link :to="{ name: 'orders', query: { filter: 'search', clientId: $route.params.id } }">
        <h1 style="margin: 10px;margin-top: 0px;color:#B082F9;text-decoration:underline;cursor:pointer">Client orders</h1>
      </router-link>
      <router-link v-if="user.verified || user.proType === 'saas'" :to="{ name: 'orders', query: { filter: 'search', workerId: $route.params.id } }">
        <h1 style="margin: 10px;margin-top: 0px;color:#B082F9;text-decoration:underline;cursor:pointer">Pro orders</h1>
      </router-link>
      <router-link v-else-if="user.tasksAssigned || user.tasksAssignedB2b" :to="{ name: 'orders', query: { filter: 'search', workerId: $route.params.id } }">
        <h1 style="margin: 10px;margin-top: 0px;color:#B082F9;text-decoration:underline;cursor:pointer">Ex-Pro orders</h1>
      </router-link>
      <router-link v-if="user.companies.length" :to="{ name: 'orders', query: { filter: 'search', companyId: user.companies[0] } }">
        <h1 style="margin: 10px;margin-top: 0px;color:#B082F9;text-decoration:underline;cursor:pointer">Company orders</h1>
      </router-link>
    </div>
    <div style="margin-bottom: 15px">
      <a :href="'https://app.intercom.com/apps/nrzl1o5k/users/show?user_id=' + $route.params.id" target="_blank">Intercom user profile</a>
    </div>
    <img :src="user.profilePhotoUrl" v-if="user.profilePhotoUrl" style="border: 1px solid gray; height: 150px" />
    <p style="max-width: 600px;margin: 20px auto">{{user.intro}}</p>
    <table border="1" style="margin: 0 auto">
      <tr>
        <td>Phone</td>
        <td>
          <span v-if="editPhoneNumber">
            <input v-model="user.phoneNumber" />
            <span class="actions"><button style="margin-left:10px" @click="updatePhoneNumber">Update</button></span>
          </span>
          <span v-else>
            <router-link :to="{ name: 'call', query: { phoneNumber: user.phoneNumber } }">{{user.phoneNumber}}</router-link>
            <span class="actions"><button style="margin-left:10px" @click="editPhoneNumber=true">Change</button></span>
            <span v-if="banned" style="color:red"> BLOCKED</span>
          </span>
        </td>
      </tr>
      <tr><td>App version</td><td>{{ user.registrationGui }}:{{user.appVersion}}:{{user.appLocale}}</td></tr>
      <tr v-if="user.email"><td>Email</td><td>{{user.email}}</td></tr>
      <tr v-if="user.businessCode">
        <td>Business code</td>
        <td>
          <router-link :to="{ name: 'users', query: { filter: 'search', businessCode: user.businessCode } }">
            {{user.businessCode}}
          </router-link>
        </td>
      </tr>
      <tr v-if="user.companyName"><td>Company name</td><td>{{user.companyName}}</td></tr>
      <tr v-if="user.vatCode"><td>Vat code</td><td>{{user.vatCode}}</td></tr>
      <tr v-if="user.iban"><td>IBAN</td><td>{{user.iban}}</td></tr>
      <tr v-if="user.serviceArea"><td>Service area</td><td>{{(user.serviceArea || {text: 'Vilnius'}).text}}, {{(user.serviceArea || {radius: 20000}).radius / 1000}}km</td></tr>
      <tr><td>Address</td>
        <td>
          <div v-if="editingAddressDetails">
            <input v-model="user.address.streetLine1" placeholder="Street address"/><br/>
            <input v-model="user.address.city" placeholder="City"/><br/>
            <input v-model="user.address.postcode" placeholder="Postcode"/>
          </div>
          <div v-else>
            <div v-if="user.address.streetLine1">
              {{user.address.streetLine1}}<br>
              {{user.address.city}}<br>
              {{user.address.postcode}}
            </div>
          </div>
          <div class="actions">
            <button v-if="editingAddressDetails" @click="updateAddressDetails">Save</button>
            <button v-else @click="editingAddressDetails=true">Edit</button>
          </div>
        </td>
      </tr>
      <tr v-if="user.passbaseAuthKey"><td>Passbase verification</td><td><a v-bind:href="'https://app.passbase.com/?id=' + user.passbaseAuthKey">{{user.passbaseAuthKey}}</a></td></tr>
      <tr v-if="user.dokobitSmartId"><td>Dokobit Smart ID</td><td>{{user.dokobitSmartId.name}} {{user.dokobitSmartId.surname}}</td></tr>
      <tr v-if="user.dokobitMobileSignature"><td>Dokobit Mobile Signature</td><td>{{user.dokobitMobileSignature.name}} {{user.dokobitMobileSignature.surname}}</td></tr>
      <tr v-if="user.priority"><td>Priority</td><td>{{user.priority}}</td></tr>
      <tr v-if="user.averageRating"><td>Average Rating</td><td>{{user.averageRating}} ({{user.reviewsCount}})</td></tr>
      <tr v-if="user.tasksAssigned"><td>Tasks Assigned B2C</td><td>{{user.tasksAssigned}}</td></tr>
      <tr v-if="user.tasksAssigned"><td>Tasks Responded B2C</td><td>{{user.tasksResponded}} ({{Math.round(user.tasksResponded/user.tasksAssigned * 100)}}%)</td></tr>
      <tr v-if="user.tasksAssigned"><td>Tasks Completed B2C</td><td>{{user.tasksCompletedB2c}} ({{Math.round(user.tasksResponded ? user.tasksCompletedB2c/user.tasksResponded * 100 : 0)}}%)</td></tr>
      <tr v-if="user.tasksAssignedB2b"><td>Tasks Completed B2B</td><td>{{user.tasksCompletedB2b}} ({{Math.round(user.tasksAssignedB2b ? user.tasksCompletedB2b/user.tasksAssignedB2b * 100 : 0)}}% out of {{user.tasksAssignedB2b}})</td></tr>
      <tr v-if="user.tasksAssigned"><td>Penalties</td><td>{{(user.penaltyHistory || []).length}}</td></tr>
      <tr v-if="user.tasksAssigned"><td>Penalty actions</td><td>
        <ul style="list-style: none;">
          <li :key="penalty.performedAt.seconds" v-for="penalty in (user.penaltyActionHistory || [])">
            <b>{{penalty.actionType}}</b> for <b>{{penalty.numPenalties}}</b> penalties by {{penalty.performedBy}} at {{new Date(penalty.performedAt.seconds * 1000).toLocaleString()}}
          </li>
        </ul>
      </td></tr>
    </table>
    <div style="display:flex; background-color: white; overflow-x: scroll" v-if="dates && dates.length">
      <DatePicker :availabilitySlots="dates" :timezone="timezone" />
    </div>
    <h1 style="margin-top:20px;margin-bottom:20px;font-size:20px">Pro status control</h1>
    <div style="border: 3px solid orange; padding: 20px; margin-top: 20px">
      <button
        style="background-color: green;padding: 10px;color:white;cursor:pointer"
        v-on:click="inititateB2bOnboarding()"
        v-if="user.verified && user.proType != 'business' && !user.businessTermsAgreementNeeded"
      >
        Initiate B2B onboarding
      </button>
      <button
        style="background-color: red;padding: 10px;color:white;cursor:pointer"
        v-on:click="removeB2bStatus(user)"
        v-if="(user.verified && user.proType) || user.businessTermsAgreementNeeded"
      >
        Remove B2B status
      </button>
      <button v-if="user.verified && !user.proType" v-on:click="promoteUser()" style="background-color: orange;padding: 10px;color:white;cursor:pointer;margin-top:20px">Promote to Business PRO</button>
      <div v-if="user.awaitingVerification || user.verified">
        <select name="removeVerificatinoReason" v-model="removeVerificatinoReason">
          <option value="photo">Unverify Reason: Profile photo</option>
          <option value="profile">Unverify Reason: Profile description</option>
          <option value="businessCode">Unverify Reason: Business Code</option>
          <option value="identity">Unverify Reason: Passbase</option>
          <option value="inactive">Unverify Reason: Inactive (ban)</option>
        </select>
        <button v-on:click="removeVerification()" style="background-color: red;padding: 10px;color:white;cursor:pointer;margin-top:20px">Remove verification status</button>
      </div>
      <button
        style="background-color: #333;padding: 10px;color:white;cursor:pointer;margin-top:20px"
        v-on:click="verifyUser(user)"
        v-if="user.awaitingVerification"
      >
        VERIFY
      </button>
      <div v-if="user.verified && !user.ordersDisabled">
        <button v-on:click="disableOrders()" style="background-color: #333;padding: 10px;color:white;cursor:pointer;margin-top:20px">Disable PRO orders</button>
      </div>
      <div style="margin-top:15px" v-if="user.ordersDisabled">ORDERS DISABLED AT {{(new Date(user.ordersDisabledAt ? user.ordersDisabledAt._seconds * 1000 : 0).toLocaleString())}}</div>
      <!-- <button v-if="user.passbaseAuthKey" v-on:click="removePassbase()" style="background-color: #333;padding: 10px;margin-left:10px;color:white;cursor:pointer;margin-top:20px">Force to repeat Passbase</button> -->
      <button v-if="user.businessCode && user.serviceArea && !user.awaitingVerification && !user.verified" v-on:click="overridePassbase()" style="background-color: #333;padding: 10px;color:white;cursor:pointer;margin-top:20px">Override Passbase Verification</button>
    </div>
    <div>
    <div v-if="user.proType === 'saas'">
      <h1 style="margin-top:20px;margin-bottom:20px;font-size:20px">SaaS partners</h1>
      <div v-for="company in companies" :key="company.id" style="margin-bottom: 10px" v-if="company.saasProsList.includes($route.params.id)">
        <router-link :to="{ name: 'companyPage', params: { id: company.id } }">
          {{ company.name }}
        </router-link>
      </div>
      <select name="saasPartners" v-model="saasPartner">
        <option v-for="company in companies"  :key="company.id"  :value="company.id">{{ company.name }}</option>
      </select>
      <button style="background-color: #333;padding: 10px;color:white;cursor:pointer;margin-left:10px" @click="addSaasPartner">Add</button>
    </div>
    <h1 style="margin-top:20px;margin-bottom:20px;font-size:20px">Business Skills</h1>
      <ul style="list-style: none; max-width: 400px; margin: 0 auto; border: 1px solid black; margin-top: 20px; padding: 10px">
        <li style="line-height: 1.5em;text-align: left" v-for="skill in user.businessSkills || []" v-bind:key="skill">
          {{storeReader.getSkillTitle(skill)}}
        </li>
      </ul>
      <router-link :to="{ name: 'businessSkills', params: { id: $route.params.id } }">
        <button style="background-color: #333;padding: 10px;color:white;cursor:pointer;margin-top:20px">Edit Business Skills</button>
      </router-link>
      <button @click="setAsSaasCandidate" v-if="!user.verified && user.proType !== 'saas' && user.proType !== 'saasCandidate'" style="background-color: #333;padding: 10px; margin-left: 10px;color:white;cursor:pointer;margin-top:20px">Set as SAAS candidate</button>
    </div>
    <h1 v-if="user.verified && user.proType"  style="margin-top:20px;margin-bottom:20px;font-size:20px">Skills</h1>
    <ul v-if="user.skills" style="list-style: none; max-width: 400px; margin: 0 auto; border: 1px solid black; margin-top: 20px; padding: 10px">
      <li style="line-height: 1.5em;text-align: left" v-for="skill in user.skills" v-bind:key="skill">
        {{storeReader.getSkillTitle(skill)}}
        <b>{{user.skillSettings[skill].rate / 100}} {{ user.skillSettings[skill].currency || 'EUR' }}</b>
      </li>
    </ul>
    <h1 style="margin-top:20px;margin-bottom:20px;font-size:20px">Active discounts</h1>
    <div><select name="currency" v-model="discountCurrency">
        <option value="EUR">EUR</option>
        <option value="PLN">PLN</option>
      </select><input style="padding: 10px" v-model="discount"/><button v-on:click="giveDiscount()" style="background-color: #333;padding: 10px;color:white;cursor:pointer;margin-bottom:20px">Give discount</button></div>
    <table border="1" style="margin: 0 auto">
      <tr><td>Amount</td><td>Expires At</td><td>Promo ID</td></tr>
      <tr v-for="discount in user.discounts" v-bind:key="discount.id"><td>{{discount.amount / 100}}{{discount.currency}}</td><td>{{(new Date(discount.expiresAt)).toLocaleString()}}</td><td>{{discount.promoId}}</td></tr>
    </table>
    <h1 style="margin-top:20px;margin-bottom:20px;font-size:20px">User referral campaigns</h1>
    <table border="1" style="margin: 0 auto">
      <tr><td>ID</td><td>Expires At</td><td>CODE</td><td>Max claims</td><td>Claim count</td></tr>
      <tr v-for="promo in user.promos" v-bind:key="promo.id.id"><td>{{promo.id}}</td><td>{{(new Date(promo.expiresAt._seconds * 1000)).toLocaleString()}}</td><td>{{promo.shareableCode}}</td><td>{{promo.maxUsers}}</td><td>{{(promo.claimedBy || []).length}}</td></tr>
    </table>
    <h1 style="margin-top:20px;margin-bottom:20px;font-size:20px" v-if="user.debtRecords">Debt records</h1>
    <table border="1" style="margin: 0 auto" v-if="user.debtRecords">
      <tr><td>Order</td><td>Amount</td><td>Registered At</td><td>Registered by</td></tr>
      <tr v-for="record in user.debtRecords" v-bind:key="record.orderId">
        <td>
          <router-link :to="{ name: 'orderPage', params: { id: record.orderId } }">{{
            record.orderId
          }}</router-link>
        </td><td>{{record.amount / 100}}</td>
        <td>{{(new Date(record.registeredAt._seconds * 1000)).toLocaleString()}}</td>
        <td>{{record.registeredBy}}</td></tr>
    </table>
    <h1 style="margin-top:20px;margin-bottom:20px;font-size:20px">User audit</h1>
    <button v-on:click="deleteEventsHistory()" style="background-color: #333;padding: 10px;color:white;cursor:pointer;margin-bottom:20px">Delete user events history</button>
    <div id="audit-table" class="data-table">
      <div class="header">
        <div>ID</div>
        <div>PublishedAt</div>
        <div>Diff</div>
      </div>
      <div v-for="audit in audits" v-bind:key="audit.id" class="row">
        <div class="cell">{{audit.id}}</div>
        <div class="cell">{{(new Date(audit.publishedAt._seconds * 1000).toLocaleString())}}</div>
        <div class="cell">{{getDiff(audit)}}</div>
      </div>
    </div>
    <br />
    <div style="color:red" v-if="user.accountDeletionRequestedAt">Account deletion requested at {{new Date(user.accountDeletionRequestedAt._seconds * 1000)}}</div>
    <button v-on:click="deleteUserProfile()" style="background-color: red;padding: 10px;color:white;cursor:pointer;margin-bottom:20px">DELETE PROFILE</button>
    <button v-if="!user.legalStatus" v-on:click="markAsOffender()" style="background-color: black;margin-left:10px;padding: 10px;color:white;cursor:pointer;margin-bottom:20px">MARK AS OFFENDER</button>
    <button v-if="user.legalStatus" v-on:click="markAsClean()" style="background-color: black;margin-left:10px;padding: 10px;color:white;cursor:pointer;margin-bottom:20px">REMOVE OFFENDER STATE</button>
    <button v-if="user.accountDeletionRequestedAt" v-on:click="removeDeletionRequest()" style="background-color: #333; margin-left: 10px; padding: 10px;color:white;cursor:pointer;margin-bottom:20px">REMOVE DELETION REQUEST</button>
  </div>
</template>

<style scoped lang="less">
table {
  td {
    padding: 10px
  }
}
#audit-table{
  grid-template-columns: auto auto auto;
}
.actions button {
  display: inline-block;
  padding: 10px;
  background-color: black;
  color: white;
  cursor: pointer;
}
</style>



<script>

import * as storeReader from '../services/storeReader';
import api from '../services/api';
import DatePicker from '../components/DatePicker.vue';
import Note from '../components/Note.vue';
import _ from 'lodash';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

const timezones = {
  PL: 'Europe/Warsaw',
  LT: 'Europe/Vilnius',
};

function difference(object, base) {
	function changes(object, base) {
		return _.transform(object, function(result, value, key) {
			if (!_.isEqual(value, base[key])) {
				result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
			}
		});
	}
	return changes(object, base);
}

export default {
  name: 'home',
  data: function() {
    return {
      storeReader,
      user: null,
      audits: [],
      discount: 0,
      discountCurrency: 'EUR',
      removeVerificatinoReason: 'photo',
      dates: [],
      banned: false,
      timezone: 'Europe/Vilnius',
      saasPartner: null,
      editingAddressDetails: false,
      editPhoneNumber: false
    }
  },
  components: {
    DatePicker,
    Note
  },
  methods: {
    verifyUser: async function(user) {
      if (
        confirm(
          "Are you sure you want to verify user " +
            user.firstName +
            " " +
            user.lastName +
            " ?"
        )
      ) {
        await api.verifyUser(this.$route.params.id);
        window.location.reload();
      }
    },
    updateAddressDetails: async function() {
      await api.updateUserAddress(this.$route.params.id, this.user.address);
      window.location.reload();
    },
    updatePhoneNumber: async function() {
      if (confirm("Make sure tha person who asks to change the phone number is not impersonating account owner! This tactic could be used to steal user account")) {
        await api.updatePhoneNumber(this.$route.params.id, this.user.phoneNumber.trim());
        window.location.reload();
      }
    },
    showCompanyOrders() {
      this.$router
        .push({ name: "orders", query: { filter: "search", companyId: this.user.companies[0] } })
        .catch(() => {});
    },
    async deleteEventsHistory() {
      if (confirm("Are you sure you want to delete this user event history?")) {
        await api.deleteAudit("users", this.$route.params.id);
      }
    },
    async overridePassbase() {
      if (confirm("Are you sure you want to skip passport verification for this user?")) {
        await api.overrideVerification(this.$route.params.id);
      }
    },
    async inititateB2bOnboarding() {
      if (confirm("Are you sure you want to initiate this user as BUSINESS PRO?")) {
        await api.inititateB2bOnboarding(this.$route.params.id);
        window.location.reload();
      }
    },
    async removeB2bStatus() {
      if (confirm("Are you sure you want to remove b2b status for this BUSINESS PRO?")) {
        await api.removeB2bStatus(this.$route.params.id);
        window.location.reload();
      }
    },
    async promoteUser() {
      if (confirm("Are you sure you want to promote this user as BUSINESS PRO?")) {
        await api.promoteUser(this.$route.params.id);
        window.location.reload();
      }
    },
    async removeVerification() {
      if (confirm("Are you sure you want to remove verification status for this user because of " + this.removeVerificatinoReason + "?")) {
        await api.removeVerification(this.$route.params.id, {reason: this.removeVerificatinoReason});
        window.location.reload();
      }
    },
    async addSaasPartner() {
      if (this.saasPartner && confirm("Please confirm adding pro as saas partner")) {
        await api.addSaasPartner(this.$route.params.id, this.saasPartner);
        window.location.reload();
      }
    },
    async disableOrders() {
      if (confirm("Are you sure you want to disable orders for this user (pro will be notified)?")) {
        await api.disableOrders(this.$route.params.id);
        window.location.reload();
      }
    },
    async removePassbase() {
      if (confirm("Are you sure you want to make this user repead passbase verification?")) {
        await api.removePassbase(this.$route.params.id);
        window.location.reload();
      }
    },
    async setAsSaasCandidate() {
      if (confirm("Are you sure you want to make this user saas pro candidate?")) {
        await api.setAsSaasCandidate(this.$route.params.id);
        window.location.reload();
      }
    },
    async deleteUserProfile() {
      if (confirm("REALLY DELETE THE PROFILE?")) {
        await api.deleteUser(this.$route.params.id);
        window.location.reload();
      }
    },
    async markAsOffender() {
      if (confirm("REALLY MARK THIS PROFILE? USER WILL NOT BE ABLE TO CREATE OR RECEIVE ORDERS. USER WILL NOT BE NOTIFIED")) {
        await api.setLegalStatus(this.$route.params.id);
        window.location.reload();
      }
    },
    async markAsClean() {
      if (confirm("This action will unblock user from creating orders. Proceed?")) {
        await api.deleteLegalStatus(this.$route.params.id);
        window.location.reload();
      }
    },
    async removeDeletionRequest() {
      await api.removeDeletionRequest(this.$route.params.id);
      window.location.reload();
    },
    async giveDiscount() {
      const value = parseInt(this.discount);
      if (!value) {
        return;
      }
      if (confirm("REALLY GIVE DISCOUNT OF " + parseInt(value) / 100 + this.discountCurrency + " ?")) {
        await api.giveDiscount(this.$route.params.id, value, this.discountCurrency);
        window.location.reload();
      }
    },
    getDiff(event) {
      if (event.data) {
        // delete event.data.updatedAt;
        // delete event.data.updatedBy;
        // delete event.data.fcmToken;
      }
      if (event.prevData) {
        // delete event.prevData.updatedAt;
        // delete event.prevData.updatedBy;
        // delete event.prevData.fcmToken;
        // delete event.prevData.updatedAt;
      }
      const diff = difference(event.data || {}, event.prevData || {});
      if (diff.fcmToken) {
        diff.fcmToken = '-';
      }
      if (diff.updatedBy) {
        diff.updatedBy = '-';
      }
      delete diff.updatedAt;
      return diff;
    }
  },
  created: async function() {
    const config = this.$store.state.config;
    const user = await api.getUser(this.$route.params.id);
    if (!user.address) {
      user.address = {};
    }
    this.user = user;
    this.companies = [];
    if (this.user.proType === 'saas') {
      this.companies = (await api.getCompanies()).filter(c => c.licenseType === 'saas');
    }
    if (config.blacklistedPhones.includes(this.user.phoneNumber)) {
      this.banned = true;
    }
    if (this.user.businessSkills && this.user.availabilityConfig) {
      this.timezone = timezones[this.user.serviceArea.country];
      if (this.user.businessSkills) {
        this.dates = (await api.getProDates(this.user.businessSkills[0], {proId: this.$route.params.id,
          country: this.user.serviceArea.country,
          location: {
            lat: this.user.serviceArea.latitude,
            lng: this.user.serviceArea.longitude
          }})).dates;
      }
    }
    document.title = [this.user.firstName, this.user.lastName].join(' ');
    this.audits = await api.getAudit("users", this.$route.params.id);
    // console.log(this.user);
  },
}
</script>
